export default __webpack_public_path__ + "static/media/Aeonik-MediumItalic.8e11942e.woff";